var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 12.1382H16V10.1382H4V12.1382ZM4 9.13818H16V7.13818H4V9.13818ZM4 6.13818H16V4.13818H4V6.13818ZM20 20.1382L16 16.1382H2C1.45 16.1382 0.979167 15.9424 0.5875 15.5507C0.195833 15.159 0 14.6882 0 14.1382V2.13818C0 1.58818 0.195833 1.11735 0.5875 0.725684C0.979167 0.334017 1.45 0.138184 2 0.138184H18C18.55 0.138184 19.0208 0.334017 19.4125 0.725684C19.8042 1.11735 20 1.58818 20 2.13818V20.1382ZM2 14.1382H16.85L18 15.2632V2.13818H2V14.1382Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.c40e0659d44c57a85e8d47c8edd23853.svg";
export { ForwardRef as ReactComponent };